<div class="overlay" (click)="toggleModal()"></div>
<div class="container-fluid d-flex flex-column g-0 m-0">
  <div class="row g-0 m-0 p-4 justify-content-start borderb top-position">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title"
        >{{ "ADD" | translate }}
        {{ "DEVICESETUP_SERVICETYPE" | translate }}</span
      >
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon
      alt="Exit"
        class="exit"
        role="button"
        src="assets/device/exit.svg"
      ></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 d-flex middle">
    <form #crudform="ngForm" (ngSubmit)="onSubmit()">
      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="name">{{ "NAME" | translate }}</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="name"
            [(ngModel)]="data.name"
            name="name"
            #name="ngModel"
            type="text"
            required
            pattern="^[^!@#$%^&*()=+{}\[\]\\;:&quot;'&lt;&gt;,.?/|]+$"
          />
          <div
            *ngIf="crudform.submitted && name.invalid"
            class="validation-error ps-2 pt-2"
          >
            {{ "NAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          <div
            *ngIf="name.errors?.['required'] && !crudform.submitted"
            class="validation-instruction ps-2 pt-2"
          >
            {{ "SETTINGS_SERVICETYPEDESC_NAME" | translate }}
          </div>
          <div
            *ngIf="name.errors?.['pattern'] && !crudform.submitted"
            class="validation-error ps-2 pt-2"
          >
            {{ "SPECIALCARACTERSERROR" | translate }}
          </div>
        </div>
      </div>
      <div class="row g-0 m-0 pt-4 pb-4 d-flex justify-content-start">
        <div class="col-md-5 d-flex justify-content-start">
          <label class="item-name" for="code">{{ "CODE" | translate }}</label>
        </div>
        <div
          class="col-md-7 pe-4 d-flex flex-column justify-content-start form-input"
        >
          <input
            id="code"
            [(ngModel)]="data.code"
            name="code"
            #code="ngModel"
            type="text"
            pattern="\d{6}"
            required
          />
          <div
            *ngIf="crudform.submitted && code.invalid"
            class="validation-error ps-2 pt-2"
          >
            Code {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
          <div
            *ngIf="code.errors?.['pattern']"
            class="validation-error ps-2 pt-2"
          >
            {{ "SETTIGNS_REGION_CODE_ERROR" | translate }}
          </div>
          <div
            *ngIf="
              !code.valid && !code.errors?.['pattern'] && !crudform.submitted
            "
            class="validation-instruction ps-2 pt-2"
          >
            {{ "SETTINGS_SERVICETYPEDESC_CODE" | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row g-0 m-0 p-3 justify-content-between bordert bottom-position">
    <div
      class="col-md-9 p-2 d-flex justify-content-start"
      (click)="toggleModal()"
    >
      <button
        type="button"
        class="crud-cancel-button pt-2 pb-2 ps-4 pe-4 rounded"
      >
        {{ "CANCEL" | translate }}
      </button>
    </div>
    <div
      class="col-md-3 p-2 d-flex justify-content-end align-items-center rounded ms-auto"
    >
      <button
        class="crud-add-button pt-2 pb-2 ps-4 pe-4 rounded"
        type="submit"
        (click)="onSubmit()"
        [disabled]="crudform.invalid"
      >
        {{ "SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
